import React from 'react';

export default function isComposing(event: KeyboardEvent | React.KeyboardEvent): boolean {
  return (
    ('isComposing' in event && event.isComposing) ||
    ('nativeEvent' in event && event.nativeEvent.isComposing)
  );
}
